(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer-pdp"]) return;
  try {
    
  (function () {
    var cartDrawer = document.getElementById('mini-cart');
    var announcement = document.querySelector('.top-announcement-wrapper');

    if (!cartDrawer) return;

    var animationFrame = null;

    function syncCartDrawerOffset() {
      animationFrame = null;

      var offset = 0;
      var isMobile = window.matchMedia('(max-width: 575px)').matches;

      if (!isMobile && announcement) {
        var announcementStyle = window.getComputedStyle(announcement);
        var announcementRect = announcement.getBoundingClientRect();
        var isVisible =
          announcementStyle.display !== 'none' &&
          announcementStyle.visibility !== 'hidden' &&
          announcementRect.width > 0 &&
          announcementRect.height > 0;

        if (isVisible) {
          offset = Math.max(0, Math.min(window.innerHeight, announcementRect.bottom));
        }
      }

      cartDrawer.style.setProperty(
        '--cart-drawer-announcement-offset',
        Math.round(offset) + 'px'
      );
      cartDrawer.classList.toggle('new-height', offset <= 0);
    }

    function scheduleCartDrawerOffsetSync() {
      if (animationFrame !== null) return;
      animationFrame = window.requestAnimationFrame(syncCartDrawerOffset);
    }

    window.addEventListener('scroll', scheduleCartDrawerOffsetSync, { passive: true });
    window.addEventListener('resize', scheduleCartDrawerOffsetSync);
    window.addEventListener('load', scheduleCartDrawerOffsetSync, { once: true });

    if (announcement && 'ResizeObserver' in window) {
      new ResizeObserver(scheduleCartDrawerOffsetSync).observe(announcement);
    }

    syncCartDrawerOffset();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chat-bot"]) return;
  try {
    
  (function (w, d, s, o, f, js, fjs) {
    w["botsonic_widget"] = o;
    w[o] =
      w[o] ||
      function () {
        (w[o].q = w[o].q || []).push(arguments);
      };
    (js = d.createElement(s)), (fjs = d.getElementsByTagName(s)[0]);
    js.id = o;
    js.src = f;
    js.async = 1;
    fjs.parentNode.insertBefore(js, fjs);
  })(window, document, "script", "Botsonic", "https://widget.writesonic.com/CDN/botsonic.min.js");
  Botsonic("init", {
    serviceBaseUrl: "https://api.botsonic.ai",
    token: "b6bc7db4-ea79-45b5-9075-447d800d9a48",
  });

  } catch(e) { console.error(e); }
})();
})();
